
import { ActionResult } from "data/StepWithAction";
import { isFieldsNotEmpty } from "functions/isFieldsNotEmpty";

import { MultiPageGuideCollection } from "../MultiPageGuideCollection";
import { SinglePageGuideCollection } from "../SinglePageGuideCollection";

import { EditorInterface, TourContext } from "./TourContext";

const tourContext: TourContext<EditorInterface> = window as any as TourContext<EditorInterface>;

const Step1CreateDocument: SinglePageGuideCollection = {
    stageNumber: 1,
    cookieName: 'article-generation-guide-stage-1',
    navigateTo: '/documents/edit/new',
    steps: [
        {
            title: 'Welcome to The Article Editor!',
            tooltipClass: 'lg',
            intro: `
            <img src="/content-generation-starter.gif" alt="intro gif" style="max-width: 100%" /><br />
            This is where the magic begins!
            `,
        },
        {
            element: '.headline-textbox',
            intro: 'To get started, enter a title for your article.',
            position: 'bottom-middle-aligned',
            isActionCompleted: (): ActionResult => isFieldsNotEmpty(['.headline-textbox'], 'You must enter a headline to continue!'),
            onBeforeNextStep: () => {
                // eslint-disable-next-line no-underscore-dangle
                const direction = (window as any).introContext._direction;
                if (direction === 'backward') {
                    document.getElementById('document-editor-tabs-tab-content')!.click();
                }
            }
        },
        {
            element: '.short-description',
            intro: 'Then, enter a brief description here.',
            position: 'bottom-middle-aligned',
            onBeforeNextStep: () => {
                // eslint-disable-next-line no-underscore-dangle
                const direction = (window as any).introContext._direction;
                if (direction === 'forward') {
                    document.getElementById('document-editor-tabs-tab-meta')!.click();
                    setTimeout(() => {
                        (window as any).introContext.refresh();
                    }, 250);
                }
            },
        },
        {
            element: '.doc-tabs',
            intro:
                'Click on the settings tab so we can adjust secondary information like the blog post category, type, target length, and keywords.  These are essential to help guide the content that is produced.',
            position: 'top',
        },
        {
            element: '#articleType',
            intro: 'Next change the article type to influence the format of the generated article.',
            position: 'top',
        },
        {
            element: '#targetLength',
            intro: 'Adjust the target length to suggest how long you would like the final article to be.  This is only a factor for the target length and not a guarantee.',
            position: 'top',
            onBeforeNextStep: () => {
                // eslint-disable-next-line no-underscore-dangle
                const direction = (window as any).introContext._direction;
                if (direction === 'backward') {
                    document.getElementById('document-editor-tabs-tab-meta')!.click();
                    setTimeout(() => {
                        (window as any).introContext.refresh(); // goToStep(3);
                    }, 250);
                }
            },
        },
        {
            element: '#seoKeyword',
            intro: 'Add keywords separated by comma here.  The generator will use these throughout the article content.',
            position: 'top',
            isActionCompleted: (): ActionResult => {
                const result = isFieldsNotEmpty(['#seoKeyword'], 'It is strongly recommended that you include an SEO Keyword before generating an article.  This is the magic dust that will help your content get noticed by Google!');
                if (result.isCompleted) {
                    document.getElementById('document-editor-tabs-tab-content')!.click();
                    setTimeout(() => {
                        (window as any).introContext.refresh(); // goToStep(3);
                    }, 10);
                }
                return result;
            }
        },
        {
            element: '.rich-editor',
            intro: 'If you would like to add additional suggestions for the model to follow, add them directly into the article content.',
            position: 'top',
        },
        {
            element: '.ai-writing-tab',
            intro: 'Now you\'re ready to execute your first prompt chain <i class="bi bi-magic"></i>.  This is your magic wand helping you generate masterpieces!  Click <strong>Run</strong> on any prompt chain to start generating content!  Click <strong>Details</strong> to look under the hood, and start customizing prompt templates.',
            position: 'left',
            isActionCompleted: (): ActionResult => {
                const content = tourContext.args.articleEditor!.app.editor.getContent();
                const isCompleted = content && content.trim() !== '';
                return { isCompleted, message: "Please try running a prompt chain again, or waiting for one to complete before proceeding." }
            }
        },
        {
            element: '.rich-editor',
            intro: 'The generated article is now available here!  You can also find prompts that will create social media posts.  Run them and then navigate to the `Social Posts` tab on the top of this page.',
            position: 'left'
        },
        {
            element: '.action-buttons',
            intro: "When you're happy with your post, click <strong>Publish</strong> to publish it directly to your website, or <strong>Schedule</strong> to publish it later!",
            position: 'top',
            tooltipClass: 'button-overlay',
            isActionCompleted: (): ActionResult => {
                const isCompleted = tourContext.args.isDocumentSubmitted ?? false;
                return {
                    isCompleted,
                    message: 'Please click one of these actions to finish the guide!'
                }
            }
        }
    ]
}

export const ArticleGenerationGuideKey = "article-generation-guide-1";

const articleGenerationGuidesCollection: MultiPageGuideCollection = {
    title: 'Team Efficiency Guide',
    key: ArticleGenerationGuideKey,
    steps: [
        Step1CreateDocument
    ]
};

export default articleGenerationGuidesCollection